module.exports = __webpack_public_path__ + "img/clock-01.a0c1b729.svg";